import { MapperHelper } from './mapper';

export type PerturbationLike = {
  name: string;
  displayName?: string | null;
};

/** User-facing perturbation label: API display_name, or title-cased snake_case fallback. */
export const formatPerturbationDisplayName = (perturbation: PerturbationLike): string => {
  const displayName = perturbation.displayName?.trim();
  if (displayName) {
    return displayName;
  }
  return MapperHelper.snakeCaseToWords(perturbation.name);
};
